<template>
  <div class="hero" :key="countdown">
    <div class="hero__overlay"></div>
    <div class="hero__body">

      <!-- LEFT -->
      <div class="hero__left">
<!--        <h1 class="hero__title" v-html="$lang.app.electronic_enroll"></h1>-->

        <div class="notice">
          <div class="notice__icon-wrap">
            <i class="bi-tools"></i>
          </div>
          <div class="notice__text">
            <strong>{{ $lang.app.preschool_maintenance_title }}</strong>
            <p>{{ $lang.app.preschool_maintenance_text }}</p>
          </div>
        </div>

        <a class="hero__map-link" href="https://open.edu.gov.kg/index.php" target="_blank" rel="noopener noreferrer">
          <i class="bi-geo-alt-fill"></i>
          <span>{{ $lang.app.available_organizations_map }}</span>
          <i class="bi-arrow-right ms-auto"></i>
        </a>
      </div>

      <!-- RIGHT -->
      <div class="hero__right">
        <div class="hero__card">
          <div class="hero__card-icon">
            <i class="bi-mortarboard-fill"></i>
          </div>
          <div class="hero__card-label" v-html="$lang.app.application_apply_school_new"></div>
          <a
            href="https://1mektep.edu.gov.kg"
            class="hero__card-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{{ $lang.app.application_apply_school }}</span>
            <i class="bi-arrow-right-circle-fill"></i>
          </a>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      countdown: 1
    }
  },
  created() {
    this.$emitter.on('langChanged', () => {
      this.countdown++
    })
    setInterval(() => {
      this.countdown++
    }, 60000)
  }
}
</script>
<style scoped>
/* ───── Hero wrapper ───── */
.hero {
  position: relative;
  min-height: 520px;
  display: flex;
  background: url('~@/assets/images/main-bg.jpg') no-repeat center center / cover;
}
.hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    120deg,
    rgba(10, 24, 60, 0.82) 0%,
    rgba(10, 24, 60, 0.65) 55%,
    rgba(60, 30, 90, 0.72) 100%
  );
  pointer-events: none;
}

/* ───── Inner layout ───── */
.hero__body {
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 64px 48px;
  gap: 48px;
  align-items: center;
}

/* ───── Left column ───── */
.hero__left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.hero__title {
  color: #fff;
  font-size: 36px;
  font-weight: 800;
  line-height: 1.3;
  margin: 0;
  text-shadow: 0 2px 12px rgba(0,0,0,0.4);
}

/* Notice card */
.notice {
  display: flex;
  gap: 18px;
  background: rgba(255, 152, 0, 0.12);
  border: 1px solid rgba(255, 152, 0, 0.5);
  border-radius: 14px;
  padding: 24px 28px;
  backdrop-filter: blur(8px);
  align-items: flex-start;
}
.notice__icon-wrap {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(255, 152, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #ffb74d;
}
.notice__text {
  flex: 1;
}
.notice__text strong {
  display: block;
  color: #ffe0b2;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 8px;
}
.notice__text p {
  color: rgba(255, 255, 255, 0.78);
  font-size: 16px;
  line-height: 1.65;
  margin: 0;
}

/* Map link */
.hero__map-link {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255,255,255,0.75);
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  padding: 14px 20px;
  border-radius: 10px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  transition: background 0.25s, color 0.25s;
}
.hero__map-link i:first-child {
  font-size: 20px;
  color: #64b5f6;
}
.hero__map-link:hover {
  background: rgba(255,255,255,0.14);
  color: #fff;
}

/* ───── Right column ───── */
.hero__right {
  width: 320px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero__card {
  width: 100%;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  backdrop-filter: blur(16px);
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0,0,0,0.35);
}
.hero__card-icon {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  background: linear-gradient(135deg, #1565c0, #0d47a1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  color: #fff;
  box-shadow: 0 8px 24px rgba(13,71,161,0.5);
}
.hero__card-label {
  color: rgba(255,255,255,0.85);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
}
.hero__card-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 14px 20px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e88e5, #1565c0);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 6px 20px rgba(21,101,192,0.5);
  transition: transform 0.2s, box-shadow 0.2s;
}
.hero__card-btn i {
  font-size: 20px;
}
.hero__card-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(21,101,192,0.65);
  color: #fff;
}

/* ───── Responsive ───── */
@media screen and (max-width: 1100px) {
  .hero__body {
    flex-direction: column;
    padding: 48px 32px 40px;
    gap: 36px;
  }
  .hero__right {
    width: 100%;
  }
  .hero__card {
    max-width: 480px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 767px) {
  .hero {
    min-height: unset;
  }
  .hero__body {
    padding: 36px 20px 32px;
    gap: 28px;
  }
  .hero__title {
    font-size: 26px;
  }
  .notice {
    flex-direction: column;
    gap: 12px;
    padding: 18px 20px;
  }
  .notice__text strong {
    font-size: 17px;
  }
  .notice__text p {
    font-size: 14px;
  }
}
@media screen and (max-width: 479px) {
  .hero__title {
    font-size: 22px;
  }
  .hero__card {
    padding: 28px 20px;
  }
}
</style>
